import { AuthT } from "../../domain/entities";
import { HttpClient } from "../../../../shared/infrastructure";
import { setAuthInCache } from "../utils/auth-storage";

const AUTHENTICATION_ENDPOINT = "auth";

const login = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<AuthT> => {
  const params = new URLSearchParams();

  params.append("email", email);
  params.append("password", password);

  const response = await HttpClient.post<{ data: AuthT }>(
    `${AUTHENTICATION_ENDPOINT}/login`,
    params,
    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
  );
  const auth = response.data.data;

  setAuthInCache(auth);

  return auth;
};

export { login };
